/**
 * Async-version av sleep.
 * @param {number} ms 
 * @returns {Promise}
 */
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Skapa en flow-control-funktion som per anrop tar en funktion som argument (som sedan förväntas ge tillbaka en promise / async). Flow-control kommer
 * serialisera de anrop som görs till den så att bara en callback-funktion anropas i taget och den kommer endast anropa den sista som finns i kö.
 * @param {number} timeout - Default-tid för hur lång tid flow-control-funktionen väntar innan den anropar den funktion som kontrolleras
 * @returns {func}
 */
export function createFlowControl(timeout = 500) {
    let promise = Promise.resolve();
    let totalCount = 0;

    return async (promiseGeneratingCallback, overrideTimeout = timeout) => {
        totalCount++;
        const count = totalCount;

        if (overrideTimeout > 0) {
            await Promise.all([sleep(overrideTimeout), promise]);
        } else {
            await promise;
        }

        if (count === totalCount) {
            promise = promiseGeneratingCallback();
        }
    };
}

/**
 * Skapa en utility som serialiserar anrop till asynkrona funktioner.
 * @returns {func}
 */
export function createSerializer() {
    let promise = Promise.resolve();

    return async (promiseGeneratingCallback) => {
        await promise;
        promise = promiseGeneratingCallback();
        
        return promise;
    };
}